import React, { useState } from "react";
import { FaCaretDown, FaCaretUp } from "react-icons/fa6";

const GDeskDifferenceCard = ({ id, title, description }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300">
      {/* Header - Only number and title visible by default */}
      <div
        className="py-4 px-5 md:px-6 cursor-pointer hover:bg-gray-50 transition-colors flex justify-between items-center"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center gap-3">
          <span className="w-8 h-8 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center text-sm font-bold">
            {id}
          </span>
          <h3 className="font-semibold text-gray-800 text-base md:text-lg">
            {title}
          </h3>
        </div>
        {isOpen ? (
          <FaCaretUp className="text-orange-600" />
        ) : (
          <FaCaretDown className="text-orange-600" />
        )}
      </div>

      {/* Description - Hidden until clicked */}
      {isOpen && (
        <div className="px-5 md:px-6 pb-4 md:pb-5 text-gray-600 border-t border-gray-100 bg-gray-50">
          <p className="text-sm md:text-base leading-relaxed">{description}</p>
        </div>
      )}
    </div>
  );
};

export default GDeskDifferenceCard;